import { connect } from 'react-redux';
import { Tag } from 'antd';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'app/pages/AgentPricing/actionTypes';
import { getAgentName, getAgentStatus } from 'app/pages/AgentPricing/modules/RefData';
import { getAgentStatusLabel, getAgentStatusTagColor } from 'app/pages/AgentPricing/utils/agentStatus';

export interface PageHeaderProps {
    suffix?: string
}

interface StateProps {
    header: string
    statusLabel?: 'Live' | 'Stopped'
    statusTagColor: string
}

type InternalProps = StateProps & PageHeaderProps;

const PageHeader = (props: InternalProps) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, marginBottom: 16 }}>
        <h1 style={{ margin: 0 }}>{props.header}</h1>
        {props.statusLabel && (
            <Tag color={props.statusTagColor}>{props.statusLabel}</Tag>
        )}
    </div>
);

const mapStateToProps = (state: any, ownProps: PageHeaderProps): StateProps => {
    const agent = getAgentName(state);
    let header = agent !== undefined ? agent : 'Unknown agent';
    if (ownProps.suffix) {
        header += ': ' + ownProps.suffix;
    }

    const status = getAgentStatus(state);

    return {
        header,
        statusLabel: getAgentStatusLabel(status),
        statusTagColor: getAgentStatusTagColor(status)
    };
};

const mapDispatchToProps = (_dispatch: ThunkDispatch<any, any, Action>) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader);